import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderWithGoogleDocs: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholder: {
		id: 'issue-create.common.fields.description-field.placeholder',
		defaultMessage:
			'Paste a Confluence or Loom link here, and we’ll generate a description automatically from the contents.',
		description:
			'Placeholder text for description field when proactive work description completer enabled',
	},
	placeholderWithGoogleDocs: {
		id: 'issue-create.common.fields.description-field.placeholder-with-google-docs',
		defaultMessage: 'Type /ai for Atlassian Intelligence or @ to mention and notify someone.',
		description: 'Placeholder text for description field when Google Docs support is enabled',
	},
});
